import React, { FC } from 'react';
import { type IconV2Props } from '../../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../../IconV2.scss';

const HowItWorks1: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`, className)}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#000" fillRule="nonzero">
      <path d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm0 1C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Z" />
      <path d="M15.016 13.078h-1.618v-1.422c.303-.052.628-.159.977-.32.27-.125.52-.318.75-.578.203-.203.336-.49.398-.86h1.493V21h-2v-7.922Z" />
    </g>
  </svg>
);

export default HowItWorks1;
